import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import {
  getCamiones,
  deleteCamion,
  getCamionById,
} from "../helpers/rutaCamiones";
import ModalCamion from "./ModalCamion";
import "../css/tableclientes.css";

const TableCamiones = () => {
  const [camiones, setCamiones] = useState({
    data: {},
    loading: true,
  });

  const [camion, setCamion] = useState({});
  const [show, setShow] = useState(false);

  useEffect(() => {
    consultaCamiones();
  }, []);

  const consultaCamiones = () => {
    getCamiones().then((datos) => {
      console.log("📦 Vehículos / maquinaria:", datos);

      setCamiones({
        data: datos,
        loading: false,
      });
    });
  };

  const handleClose = () => {
    setShow(false);
    consultaCamiones();
  };

  const handleShow = () => setShow(true);

  const modificaCamion = (id) => {
    getCamionById(id).then((resp) => {
      if (resp.ok) {
        setCamion(resp.camion);
        handleShow();
      } else {
        console.error("❌ Error al obtener vehículo:", resp.error);
      }
    });
  };

  const eliminarCamion = (id) => {
    const confirmar = window.confirm(
      "¿Está seguro que desea borrar este vehículo / maquinaria?"
    );

    if (confirmar) {
      deleteCamion(id).then(() => {
        consultaCamiones();
      });
    }
  };

  const listaCamiones = camiones.data?.camiones || [];


  const tdSmall = {
    fontSize: "11px",
    verticalAlign: "middle",
  };

  const tdCenter = {
    ...tdSmall,
    textAlign: "center",
  };

  const tdRight = {
    ...tdSmall,
    textAlign: "right",
  };

  const tdNoWrap = {
    ...tdSmall,
    whiteSpace: "nowrap",
  };

  return (
    <div className="table-container">
      {!camiones.loading && (
        <>
          <div className="col-12 mt-4" />

          <div>
            <Table
              striped
              bordered
              hover
              responsive
              className="table-container"
              style={{
                tableLayout: "fixed",
                minWidth: "1150px",
                fontSize: "11px",
              }}
            >
              <colgroup>
                <col style={{ width: "70px" }} />   {/* Acciones */}
                <col style={{ width: "45px" }} />   {/* Nro */}
                <col style={{ width: "180px" }} />  {/* Vehículo */}
                <col style={{ width: "100px" }} />  {/* Patente */}
                <col style={{ width: "105px" }} />  {/* Tipo */}
                <col style={{ width: "70px" }} />   {/* Control */}
                <col style={{ width: "95px" }} />   {/* Combustible */}
                <col style={{ width: "100px" }} />  {/* Último Km */}
                <col style={{ width: "120px" }} />  {/* Último Horómetro */}
                <col style={{ width: "180px" }} />  {/* Observaciones */}
              </colgroup>

              <thead>
                <tr className="header">
                  <th>Acciones</th>
                  <th>Nro</th>
                  <th>Vehículo / Maquinaria</th>
                  <th>Patente / ID</th>
                  <th>Tipo</th>
                  <th>Control</th>
                  <th>Combustible</th>
                  <th>Último Km</th>
                  <th>Último Horómetro</th>
                  <th>Observaciones</th>
                </tr>
              </thead>

              <tbody>
                {listaCamiones.map((camion) =>
                  camion.activo ? (
                    <tr key={camion._id}>
                      <td style={tdCenter}>
                        <button
                          className="btn btn-primary btn-sm"
                          onClick={() => modificaCamion(camion._id)}
                          title="Modificar"
                          style={{ padding: "2px 6px", marginRight: "4px" }}
                        >
                          <i className="fa fa-pencil-square-o" aria-hidden="true" />
                        </button>

                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() => eliminarCamion(camion._id)}
                          title="Eliminar"
                          style={{ padding: "2px 6px" }}
                        >
                          <i className="fa fa-trash-o" aria-hidden="true" />
                        </button>
                      </td>

                      <td style={tdCenter}>{camion.codcam}</td>

                      <td
                        style={{
                          ...tdSmall,
                          fontWeight: "600",
                          whiteSpace: "normal",
                          lineHeight: "1.25",
                        }}
                      >
                        {camion.camion}
                      </td>

                      <td style={tdCenter}>{camion.patente}</td>

                      <td style={tdCenter}>{camion.tipoUnidad || "CAMIONETA"}</td>

                      <td style={tdCenter}>{camion.modoControl || "KM"}</td>

                      <td style={tdCenter}>
                        {camion.combustibleHabitual || "GASOIL"}
                      </td>

                      <td style={tdRight}>
                        {camion.ultimoKmTablero
                          ? Number(camion.ultimoKmTablero).toLocaleString("es-AR")
                          : "-"}
                      </td>

                      <td style={tdRight}>
                        {camion.ultimoHorometro
                          ? Number(camion.ultimoHorometro).toLocaleString("es-AR")
                          : "-"}
                      </td>

                      <td style={tdSmall}>{camion.observaciones || "-"}</td>
                    </tr>
                  ) : null
                )}
              </tbody>
            </Table>
          </div>

          <ModalCamion show={show} handleClose={handleClose} camion={camion} />
        </>
      )}
    </div>
  );
};

export default TableCamiones;